import { createFileRoute, useParams } from '@tanstack/react-router';
import { Suspense } from 'react';

import HStack from '@/components/Layout/HStack';
import VStack from '@/components/Layout/VStack';
import type { NavigationSectionGroup } from '@/components/Navigation/NavigationCard';
import NavigationCard from '@/components/Navigation/NavigationCard';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { defaultNS, useTranslation } from '@/lib/i18n';

import { useAggregateDataPipelineDetail } from '../../-query';

import { PrioritySettingSection } from './-components/PrioritySettingSection';

export const Route = createFileRoute(
  '/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail/priority-setting/',
)({
  component: PrioritySetting,
});

function PrioritySetting() {
  return (
    <Suspense>
      <Content />
    </Suspense>
  );
}

function Content() {
  const { id } = useParams({
    from: '/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail',
  });
  const { t } = useTranslation(defaultNS, {
    keyPrefix: 'pages.dataConnector.aggregateDataPipeline.detail',
  });
  useDocumentTitle(t('prioritySetting.title'));
  const { data } = useAggregateDataPipelineDetail(id);

  const navigationSections: NavigationSectionGroup[] = [
    {
      titleLabel: t('prioritySetting.title'),
      to: '/settings/data-connector/inbound/aggregate-data-pipeline/$id/priority-setting',
      hash: 'priority-setting',
    },
  ];

  return (
    <HStack className="gap-0 px-12 py-6">
      <div className="sticky top-6 w-52 shrink-0">
        <NavigationCard sections={navigationSections} />
      </div>

      <VStack className="flex-1 gap-6">
        <PrioritySettingSection pipelineId={id} data={data} />
      </VStack>
    </HStack>
  );
}
